import { DatePicker } from "antd";
import dayjs from "dayjs";
import { DateInputProps } from "../../types/common";

export const DateInput = (props: DateInputProps) => {
  const { value, disabledDate, onChange, required, ...rest } = props;

  const getDisabledDate = () => {
    if (typeof disabledDate === "function") {
      return disabledDate;
    }
    // If disabledDate is true, disable dates after today
    if (disabledDate === true) {
      return (current: any) => current && current.isAfter(dayjs(), "day");
    }
    return undefined;
  };

  return (
    <DatePicker
      onChange={(date: any) => onChange(date)}
      value={value}
      style={{ width: "100%", height: 36 }}
      getPopupContainer={(node: HTMLElement): HTMLElement =>
        node.parentNode as HTMLElement
      }
      disabledDate={getDisabledDate()}
      required={required}
      {...rest}
    />
  );
};
